<script setup lang="ts">
import { TransitionPresets, useTransition } from '@vueuse/core'

interface IProps {
  currentValue: number
  currencyId: number
}

const props = defineProps<IProps>()

// Count up from zero once mounted, so SSR and hydration both render the initial zero
const isMounted = ref(false)
onMounted(() => (isMounted.value = true))

const rate = useTransition(() => (isMounted.value ? props.currentValue : 0), {
  duration: 500,
  easing: TransitionPresets.easeOutQuad
})
</script>

<template>
  <strong>{{ useCurrencyFormat(rate, currencyId, false) }}</strong>
</template>
